import { render } from "./MinutasSupervisor.vue?vue&type=template&id=fb6270ba&scoped=true"
import script from "./MinutasSupervisor.vue?vue&type=script&lang=js"
export * from "./MinutasSupervisor.vue?vue&type=script&lang=js"

import "./MinutasSupervisor.vue?vue&type=style&index=0&id=fb6270ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6270ba"]])

export default __exports__